import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Inject, Output, Input, NgModule } from '@angular/core';
import * as i1$1 from '@angular/forms';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@angular/material/snack-bar';
import { MatSnackBarConfig, MatSnackBarModule } from '@angular/material/snack-bar';
import * as i1 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i2 from '@angular/platform-browser';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i6 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i7 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i8 from '@angular/material/form-field';
import * as i9 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i10 from '@angular/material/core';
import * as i11 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';

class CoberturasAutoService {
    constructor() { }
    static buscaValue(constant, viewValue) {
        let busca = constant.find(option => option.viewValue === viewValue);
        if (busca)
            return busca?.value;
        else
            return false;
    }
    static buscaViewValue(constant, value) {
        let busca = constant.find(option => option.value === value);
        if (busca)
            return busca?.viewValue;
        else
            return false;
    }
    desabilitaCampos(arrayNomeCampos, formulario) {
        arrayNomeCampos.forEach(campo => {
            formulario.controls[campo].setValue(CoberturasAutoService.formatField(campo, formulario));
            formulario.controls[campo].disable();
        });
    }
    static formatField(nomeCampo, formulario) {
        switch (nomeCampo) {
            case 'carroReserva':
            case 'valorDeNovo':
                return 0;
            case 'tipoFranquia':
                return formulario.controls[nomeCampo].value;
            default:
                return false;
        }
    }
    habilitaCampos(arrayNomeCampos, formulario) {
        arrayNomeCampos.forEach(campo => formulario.controls[campo].enable());
    }
    static intervalNumberToViewValue(val) {
        let generateInterval = function (obj) {
            let valAtual = obj.min;
            let limite = obj.max;
            let interval = obj.interval;
            let arr = [];
            while (valAtual <= limite) {
                arr.push({ value: valAtual, viewValue: valAtual.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) });
                valAtual = valAtual + interval;
            }
            return arr;
        };
        if (Array.isArray(val)) {
            let arr = [];
            val.map(function (v) {
                arr = [...arr, ...generateInterval(v)];
            });
            return arr;
        }
        else {
            return generateInterval(val);
        }
    }
    static objectToViewValue(val, ignorarOrdenacao) {
        let arr = [];
        for (let idx in val) {
            let formatIdx = parseInt(idx);
            formatIdx = isNaN(formatIdx) ? idx : (isFinite(formatIdx) ? formatIdx : idx);
            arr.push({ value: formatIdx, viewValue: val[idx] });
        }
        return ignorarOrdenacao ? arr : arr.sort(function (a, b) {
            return (a.viewValue > b.viewValue) ? 1 : ((b.viewValue > a.viewValue) ? -1 : 0);
        });
    }
    static ɵfac = function CoberturasAutoService_Factory(t) { return new (t || CoberturasAutoService)(); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CoberturasAutoService, factory: CoberturasAutoService.ɵfac, providedIn: 'root' });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CoberturasAutoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [], null); })();

class ConstantCoberturasAuto {
    static tipoCoberturaMulti = [
        { value: 1, viewValue: "Básico" },
        { value: 2, viewValue: "Normal" },
        { value: 3, viewValue: "Diferenciada" },
        { value: 4, viewValue: "Personalizada" },
    ];
    static tipoCoberturaApice = [
        { value: 1, viewValue: "Prata" },
        { value: 2, viewValue: "Ouro" },
        { value: 3, viewValue: "Diamante" },
        { value: 4, viewValue: "Personalizada" },
    ];
    static tipoCobertura = {
        1: ConstantCoberturasAuto.tipoCoberturaMulti,
        3: ConstantCoberturasAuto.tipoCoberturaApice
    };
    static tipoFranquia = [
        { value: 1, viewValue: "Reduzida" },
        { value: 2, viewValue: "Obrigatória" },
        { value: 3, viewValue: "Majorada" },
    ];
    static pctAjuste = [
        { value: 80, viewValue: "80 %" },
        { value: 85, viewValue: "85 %" },
        { value: 90, viewValue: "90 %" },
        { value: 95, viewValue: "95 %" },
        { value: 100, viewValue: "100 %" },
        { value: 105, viewValue: "105 %" },
        { value: 110, viewValue: "110 %" },
    ];
    static valorDeNovo = [
        { value: 0, viewValue: "Não contratado" },
        { value: 3, viewValue: "3 meses" },
        { value: 6, viewValue: "6 meses" },
        { value: 9, viewValue: "9 meses" },
        { value: 12, viewValue: "12 meses" },
    ];
    static valoresMateriaisECorporais = CoberturasAutoService.intervalNumberToViewValue([{
            min: 10000,
            max: 75000,
            interval: 5000
        }, {
            min: 80000,
            max: 100000,
            interval: 25000
        }, {
            min: 100000,
            max: 300000,
            interval: 50000
        }, {
            min: 400000,
            max: 1000000,
            interval: 100000
        }]);
    static valoresDanosMorais = CoberturasAutoService.intervalNumberToViewValue([{
            min: 0,
            max: 1000,
            interval: 1000
        }, {
            min: 1500,
            max: 5000,
            interval: 500
        }, {
            min: 6000,
            max: 9000,
            interval: 1000
        }, {
            min: 10000,
            max: 20000,
            interval: 1000
        }, {
            min: 25000,
            max: 30000,
            interval: 5000
        }, {
            min: 40000,
            max: 50000,
            interval: 10000
        }, {
            min: 75000,
            max: 100000,
            interval: 25000
        }]);
    static valoresAppMorteEInvalidez = CoberturasAutoService.intervalNumberToViewValue([{
            min: 0,
            max: 50000,
            interval: 5000
        }]);
    static carroReserva = [
        { value: 0, viewValue: "Não contratar" },
        { value: 1, viewValue: "Básico 7 dias" },
        { value: 2, viewValue: "Básico 15 dias" },
        { value: 3, viewValue: "Básico 30 dias" },
    ];
    static simOuNao = [
        { value: true, viewValue: 'Sim' },
        { value: false, viewValue: 'Não' },
    ];
    static guinchoKm = [
        { value: 1, viewValue: '200km' },
        { value: 2, viewValue: '400km' },
        { value: 3, viewValue: '600km' },
        { value: 4, viewValue: '800km' },
        { value: 5, viewValue: '1000km' },
        { value: 6, viewValue: 'Ilimitado' },
        { value: 7, viewValue: 'Ilimitado TOP' },
    ];
    static blindagem = CoberturasAutoService.intervalNumberToViewValue([{
            min: 0,
            max: 100000,
            interval: 10000
        }]);
    static cobertura = {
        1: 'Compreensiva',
        3: 'RCF',
    };
    static objSelects = {
        tipoCobertura: undefined,
        tipoFranquia: ConstantCoberturasAuto.tipoFranquia,
        pctAjuste: ConstantCoberturasAuto.pctAjuste,
        valorDeNovo: ConstantCoberturasAuto.valorDeNovo,
        isDanosMateriais: ConstantCoberturasAuto.valoresMateriaisECorporais,
        isDanosCorporais: ConstantCoberturasAuto.valoresMateriaisECorporais,
        isDanosMorais: ConstantCoberturasAuto.valoresDanosMorais,
        isAppMorte: ConstantCoberturasAuto.valoresAppMorteEInvalidez,
        isAppInvalidez: ConstantCoberturasAuto.valoresAppMorteEInvalidez,
        carroReserva: ConstantCoberturasAuto.carroReserva,
        simOuNao: ConstantCoberturasAuto.simOuNao,
        guinchoKm: ConstantCoberturasAuto.guinchoKm,
        blindagem: ConstantCoberturasAuto.blindagem,
        tpCobertura: CoberturasAutoService.objectToViewValue(ConstantCoberturasAuto.cobertura)
    };
    static tipoVeiculo = {
        CARRO: 'v',
        MOTOCICLETA: 'm',
        CAMINHAO: 'c'
    };
    static camposHabilitaRCF = [
        'tipoFranquia',
        'carroReserva',
        'higienizacao',
        'martelinhoOuro',
        'vidros',
        'reparoRapido',
        'protecaoPneuRodas',
        'carroReservaAr',
        'despesasExtra'
    ];
    static camposDesabilitaRCF = [
        'tipoFranquia',
        'farolRetrovis',
        'tetoSolar',
        'lantFarolAux',
        'higienizacao',
        'martelinhoOuro',
        'vidros',
        'reparoRapido',
        'protecaoPneuRodas',
        'carroReservaAr',
        'despesasExtra',
        'carroReserva'
    ];
    static camposVidros = [
        'farolRetrovis',
        'tetoSolar',
        'lantFarolAux'
    ];
    static camposFarol = [
        'tetoSolar',
        'lantFarolAux'
    ];
}

class IconsService {
    matIconRegistry;
    domSanitizer;
    constructor(matIconRegistry, domSanitizer) {
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
    }
    registerIcons(icons) {
        this.loadIcons(icons, 'assets/icons');
    }
    loadIcons(iconKeys, iconUrl) {
        iconKeys.forEach(key => {
            this.matIconRegistry.addSvgIcon(key, this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconUrl}/${key}.svg`));
        });
    }
    static ɵfac = function IconsService_Factory(t) { return new (t || IconsService)(i0.ɵɵinject(i1.MatIconRegistry), i0.ɵɵinject(i2.DomSanitizer)); };
    static ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: IconsService, factory: IconsService.ɵfac, providedIn: 'root' });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(IconsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [{ type: i1.MatIconRegistry }, { type: i2.DomSanitizer }], null); })();

function CoberturasAutoComponent_h2_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h2");
    i0.ɵɵtext(1, "Pacotes e coberturas");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r1.value);
    i0.ɵɵattribute("custom-reflect-value", v_r1.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r1.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r2 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r2.value);
    i0.ɵɵattribute("custom-reflect-value", v_r2.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r2.viewValue, " ");
} }
function CoberturasAutoComponent_mat_option_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r3 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r3.value);
    i0.ɵɵattribute("custom-reflect-value", v_r3.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r3.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r4.value);
    i0.ɵɵattribute("custom-reflect-value", v_r4.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r4.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r5 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r5.value);
    i0.ɵɵattribute("custom-reflect-value", v_r5.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r5.viewValue, " ");
} }
function CoberturasAutoComponent_mat_option_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r6 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r6.value);
    i0.ɵɵattribute("custom-reflect-value", v_r6.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r6.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_46_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r7 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r7.value);
    i0.ɵɵattribute("custom-reflect-value", v_r7.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r7.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_47_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r8 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r8.value);
    i0.ɵɵattribute("custom-reflect-value", v_r8.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r8.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_53_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r9 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r9.value);
    i0.ɵɵattribute("custom-reflect-value", v_r9.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r9.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_59_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_64_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r10 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r10.value);
    i0.ɵɵattribute("custom-reflect-value", v_r10.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r10.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_65_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_form_field_66_mat_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const b_r13 = ctx.$implicit;
    i0.ɵɵproperty("value", b_r13.value);
    i0.ɵɵattribute("custom-reflect-value", b_r13.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", b_r13.viewValue, " ");
} }
function CoberturasAutoComponent_mat_form_field_66_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 11)(1, "mat-label");
    i0.ɵɵtext(2, "Blindagem");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-select", 33);
    i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_mat_form_field_66_Template_mat_select_selectionChange_3_listener() { i0.ɵɵrestoreView(_r11); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.setaCoberturaPersonalizada()); });
    i0.ɵɵtemplate(4, CoberturasAutoComponent_mat_form_field_66_mat_option_4_Template, 2, 3, "mat-option", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", ctx_r11.isRecalculo && !(ctx_r11.habCampos == null ? null : ctx_r11.habCampos.CALCULOS_BLINDAGEM))("ngClass", !ctx_r11.isRecalculo ? "col-12 col-md-6 col-lg-6 col-xl-3" : "col-12");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r11.selects.blindagem);
} }
function CoberturasAutoComponent_mat_form_field_67_mat_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r15 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r15.value);
    i0.ɵɵattribute("custom-reflect-value", v_r15.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r15.viewValue, " ");
} }
function CoberturasAutoComponent_mat_form_field_67_mat_error_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_form_field_67_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 11)(1, "mat-label");
    i0.ɵɵtext(2, "Carro Reserva");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-select", 34);
    i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_mat_form_field_67_Template_mat_select_selectionChange_3_listener() { i0.ɵɵrestoreView(_r14); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.setaCoberturaPersonalizada()); });
    i0.ɵɵtemplate(4, CoberturasAutoComponent_mat_form_field_67_mat_option_4_Template, 2, 3, "mat-option", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CoberturasAutoComponent_mat_form_field_67_mat_error_5_Template, 2, 0, "mat-error", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", ctx_r11.isRecalculo && !(ctx_r11.habCampos == null ? null : ctx_r11.habCampos.CALCULOS_CARRORESERVA))("ngClass", !ctx_r11.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r11.selects.carroReserva);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r11.formCoberturas.get("carroReserva").hasError("required"));
} }
function CoberturasAutoComponent_mat_form_field_68_mat_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r17 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r17.value);
    i0.ɵɵattribute("custom-reflect-value", v_r17.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r17.viewValue, " ");
} }
function CoberturasAutoComponent_mat_form_field_68_mat_error_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_form_field_68_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 11)(1, "mat-label");
    i0.ɵɵtext(2, "Carro Reserva c/ Ar");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-select", 35);
    i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_mat_form_field_68_Template_mat_select_selectionChange_3_listener() { i0.ɵɵrestoreView(_r16); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.setaCoberturaPersonalizada()); });
    i0.ɵɵtemplate(4, CoberturasAutoComponent_mat_form_field_68_mat_option_4_Template, 2, 3, "mat-option", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CoberturasAutoComponent_mat_form_field_68_mat_error_5_Template, 2, 0, "mat-error", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", ctx_r11.isRecalculo && !(ctx_r11.habCampos == null ? null : ctx_r11.habCampos.CALCULOS_CARRORESERVA))("ngClass", !ctx_r11.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r11.selects.simOuNao);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r11.formCoberturas.get("carroReservaAr").hasError("required"));
} }
function CoberturasAutoComponent_mat_option_73_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r18 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r18.value);
    i0.ɵɵattribute("custom-reflect-value", v_r18.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r18.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_74_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_79_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r19 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r19.value);
    i0.ɵɵattribute("custom-reflect-value", v_r19.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r19.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_80_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_85_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r20 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r20.value);
    i0.ɵɵattribute("custom-reflect-value", v_r20.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r20.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_86_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_91_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r21 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r21.value);
    i0.ɵɵattribute("custom-reflect-value", v_r21.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r21.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_92_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_97_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r22 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r22.value);
    i0.ɵɵattribute("custom-reflect-value", v_r22.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r22.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_98_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_option_103_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r23 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r23.value);
    i0.ɵɵattribute("custom-reflect-value", v_r23.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r23.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_104_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_form_field_105_mat_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r25 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r25.value);
    i0.ɵɵattribute("custom-reflect-value", v_r25.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r25.viewValue, " ");
} }
function CoberturasAutoComponent_mat_form_field_105_mat_error_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_form_field_105_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 11)(1, "mat-label");
    i0.ɵɵtext(2, "Vidros");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-select", 36);
    i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_mat_form_field_105_Template_mat_select_selectionChange_3_listener() { i0.ɵɵrestoreView(_r24); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.setaCoberturaPersonalizada()); });
    i0.ɵɵtemplate(4, CoberturasAutoComponent_mat_form_field_105_mat_option_4_Template, 2, 3, "mat-option", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CoberturasAutoComponent_mat_form_field_105_mat_error_5_Template, 2, 0, "mat-error", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", ctx_r11.isRecalculo && !(ctx_r11.habCampos == null ? null : ctx_r11.habCampos.CALCULOS_VIDROS))("ngClass", !ctx_r11.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r11.selects.simOuNao);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r11.formCoberturas.get("vidros").hasError("required"));
} }
function CoberturasAutoComponent_mat_option_110_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r26 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r26.value);
    i0.ɵɵattribute("custom-reflect-value", v_r26.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r26.viewValue, " ");
} }
function CoberturasAutoComponent_mat_error_111_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1, "Por favor, selecione uma op\u00E7\u00E3o.");
    i0.ɵɵelementEnd();
} }
function CoberturasAutoComponent_mat_form_field_112_mat_option_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r28 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r28.value);
    i0.ɵɵattribute("custom-reflect-value", v_r28.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r28.viewValue, " ");
} }
function CoberturasAutoComponent_mat_form_field_112_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-form-field", 11)(1, "mat-label");
    i0.ɵɵtext(2, "Teto Solar");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-select", 37);
    i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_mat_form_field_112_Template_mat_select_selectionChange_3_listener() { i0.ɵɵrestoreView(_r27); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.setaCoberturaPersonalizada()); });
    i0.ɵɵtemplate(4, CoberturasAutoComponent_mat_form_field_112_mat_option_4_Template, 2, 3, "mat-option", 9);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", ctx_r11.isRecalculo && !(ctx_r11.habCampos == null ? null : ctx_r11.habCampos.CALCULOS_TETOSOLAR))("ngClass", !ctx_r11.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r11.selects.simOuNao);
} }
function CoberturasAutoComponent_mat_option_117_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 32);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const v_r29 = ctx.$implicit;
    i0.ɵɵproperty("value", v_r29.value);
    i0.ɵɵattribute("custom-reflect-value", v_r29.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", v_r29.viewValue, " ");
} }
function CoberturasAutoComponent_div_119_button_5_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 45);
    i0.ɵɵlistener("click", function CoberturasAutoComponent_div_119_button_5_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r31); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.matStepRoute("next")); });
    i0.ɵɵelementStart(1, "span", 41);
    i0.ɵɵtext(2, "CALCULAR");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵproperty("matTooltip", "ENVIAR PARA CALCULO")("matTooltipPosition", "right");
} }
function CoberturasAutoComponent_div_119_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 46);
    i0.ɵɵlistener("click", function CoberturasAutoComponent_div_119_button_6_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r32); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.matStepRoute("ajuste")); });
    i0.ɵɵelementStart(1, "span", 41);
    i0.ɵɵtext(2, "PR\u00D3XIMO");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵproperty("matTooltipPosition", "right");
} }
function CoberturasAutoComponent_div_119_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r33 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47)(1, "button", 48);
    i0.ɵɵlistener("click", function CoberturasAutoComponent_div_119_div_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r33); const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.matStepRoute("ajuste")); });
    i0.ɵɵelementStart(2, "div", 49);
    i0.ɵɵelement(3, "mat-icon", 50);
    i0.ɵɵelementStart(4, "span", 51);
    i0.ɵɵtext(5, "Ajustes por seguradora");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("svgIcon", "cogs");
} }
function CoberturasAutoComponent_div_119_Template(rf, ctx) { if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38)(1, "div", 39)(2, "button", 40);
    i0.ɵɵlistener("click", function CoberturasAutoComponent_div_119_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r30); const ctx_r11 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r11.matStepRoute("previous")); });
    i0.ɵɵelementStart(3, "span", 41);
    i0.ɵɵtext(4, "VOLTAR");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(5, CoberturasAutoComponent_div_119_button_5_Template, 3, 2, "button", 42)(6, CoberturasAutoComponent_div_119_button_6_Template, 3, 1, "button", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CoberturasAutoComponent_div_119_div_7_Template, 6, 1, "div", 44);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matTooltipPosition", "left");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r11.possuiAjustePorSeguradora || !ctx_r11.ajustePorSeguradoraDisponivel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r11.possuiAjustePorSeguradora && ctx_r11.ajustePorSeguradoraDisponivel && ctx_r11.tipoVeiculo === "v");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r11.ajustePorSeguradoraDisponivel && ctx_r11.tipoVeiculo === "v");
} }
class CoberturasAutoComponent {
    formBuilder;
    coberturasService;
    _snackBar;
    iconsService;
    ajustePorSeguradoraService;
    cotacaoAutoService;
    calculo;
    coberturas;
    formCoberturas;
    selects = ConstantCoberturasAuto.objSelects;
    tipoCobertura;
    tipoVeiculo;
    tiposDeVeiculo = ConstantCoberturasAuto.tipoVeiculo;
    veiculoZero;
    matStepRouteEvent = new EventEmitter();
    //recalculo
    isRecalculo = false;
    habCampos;
    possuiAjustePorSeguradora = false;
    ajustePorSeguradoraDisponivel = false;
    set listaCampo(value) {
        this.habCampos = value;
    }
    constructor(formBuilder, coberturasService, _snackBar, iconsService, ajustePorSeguradoraService, cotacaoAutoService) {
        this.formBuilder = formBuilder;
        this.coberturasService = coberturasService;
        this._snackBar = _snackBar;
        this.iconsService = iconsService;
        this.ajustePorSeguradoraService = ajustePorSeguradoraService;
        this.cotacaoAutoService = cotacaoAutoService;
        this.formCoberturas = this.formBuilder.group({
            tipoCobertura: new FormControl('', [Validators.required]),
            tipoFranquia: new FormControl('', [Validators.required]),
            pctAjuste: new FormControl('', [Validators.required]),
            isDanosMateriais: new FormControl('', [Validators.required]),
            isDanosCorporais: new FormControl('', [Validators.required]),
            isDanosMorais: new FormControl('', [Validators.required]),
            isAppMorte: new FormControl('', [Validators.required]),
            isAppInvalidez: new FormControl('', [Validators.required]),
            isBlindagemValor: new FormControl('', []),
            carroReserva: new FormControl('', [Validators.required]),
            carroReservaAr: new FormControl('', [Validators.required]),
            despesasExtra: new FormControl('', [Validators.required]),
            guinchoKm: new FormControl('', [Validators.required]),
            protecaoPneuRodas: new FormControl('', [Validators.required]),
            reparoRapido: new FormControl('', [Validators.required]),
            martelinhoOuro: new FormControl('', [Validators.required]),
            higienizacao: new FormControl('', [Validators.required]),
            vidros: new FormControl('', [Validators.required]),
            farolRetrovis: new FormControl('', [Validators.required]),
            tetoSolar: new FormControl('', []),
            lantFarolAux: new FormControl('', []),
            valorDeNovo: new FormControl('', []),
        });
        this.tipoCobertura = new FormControl(1, [Validators.required]);
        this.iconsService.registerIcons(["cogs"]);
    }
    ngOnInit() {
    }
    changeCobertura(coberturaSelecionada) {
        if (CoberturasAutoService.buscaViewValue(this.selects.tipoCobertura, coberturaSelecionada) !== 'Personalizada') {
            let cobertura;
            cobertura = this.coberturas.find(cobertura => cobertura?.tipoCobertura === coberturaSelecionada);
            cobertura.pctAjuste = !cobertura?.pctAjuste ? 100 : cobertura.pctAjuste;
            this.setaValoresCampos(cobertura);
        }
        else {
            if (CoberturasAutoService.buscaViewValue(this.selects.tipoCobertura, this.calculo?.tipoCobertura) === 'Personalizada')
                this.setaValoresCampos(this.calculo);
        }
    }
    getCoberturas() {
        let object = this.formCoberturas.getRawValue();
        if (object && typeof (object) === 'object')
            object['valorDeNovo'] = this.formataValores('valorDeNovo', object['valorDeNovo']);
        if (this.tipoVeiculo != 'v')
            delete object['isBlindagemValor'];
        return object;
    }
    getInfosDraft(draft) {
        try {
            if (draft) {
                this.tipoVeiculo = draft.automoveis[0].tipo;
                this.tipoCobertura.setValue(draft.tpCobertura ? draft.tpCobertura : 1);
                this.veiculoZero = draft.automoveis ? draft.automoveis[0].zeroKm : false;
            }
        }
        catch (error) {
            console.error('Erro ao pegar informações do draft.');
        }
    }
    initialize(coberturasDefault, currentVersion, draft, recalculo = false, seguradorasStatus) {
        this.coberturas = coberturasDefault;
        this.setaSelectsOptions(draft?.aplicacaoId);
        this.getInfosDraft(draft);
        this.setaValores(currentVersion);
        // this.verificaAjustePorSeguradora(currentVersion, draft, seguradorasStatus);
        this.isRecalculo = recalculo;
    }
    verificaAjustePorSeguradora(version, draft, seguradorasStatus) {
        this.possuiAjustePorSeguradora = this.ajustePorSeguradoraService.possuiAjustePorSeguradora(version);
        this.ajustePorSeguradoraDisponivel = this.ajustePorSeguradoraService.ajusteDisponivel(this.cotacaoAutoService.getCalcObject(draft, seguradorasStatus, this.getCoberturas()));
    }
    matStepRoute(action) {
        if (action == 'next') {
            this.clicaBotaoSubmit();
            if (this.formCoberturas.valid) {
                this.matStepRouteEvent.emit(action);
            }
            else {
                this.openSnackbarModal('Preencha todas informações obrigatórias antes de prosseguir.');
            }
        }
        else {
            this.matStepRouteEvent.emit(action);
        }
    }
    verificaCoberturas() {
        this.verificaCarroReserva();
        this.verificaFarol();
        this.verificaVidros();
        this.verificaRCF();
        this.verificaValorDeNovo();
    }
    verificaCarroReserva() {
        if (!this.formCoberturas?.controls.carroReserva.value)
            this.coberturasService.desabilitaCampos(['carroReservaAr'], this.formCoberturas);
        else
            this.coberturasService.habilitaCampos(['carroReservaAr'], this.formCoberturas);
    }
    verificaFarol() {
        if (this.formCoberturas?.controls.farolRetrovis.value)
            this.coberturasService.habilitaCampos(ConstantCoberturasAuto.camposFarol, this.formCoberturas);
        else
            this.coberturasService.desabilitaCampos(ConstantCoberturasAuto.camposFarol, this.formCoberturas);
    }
    verificaVidros() {
        if (!this.formCoberturas?.controls.vidros.value)
            this.coberturasService.desabilitaCampos(ConstantCoberturasAuto.camposVidros, this.formCoberturas);
        else
            this.coberturasService.habilitaCampos(['farolRetrovis'], this.formCoberturas);
    }
    verificaRCF() {
        if (ConstantCoberturasAuto.cobertura[this.tipoCobertura.value] === 'RCF')
            this.coberturasService.desabilitaCampos(ConstantCoberturasAuto.camposDesabilitaRCF, this.formCoberturas);
        else
            this.coberturasService.habilitaCampos(ConstantCoberturasAuto.camposHabilitaRCF, this.formCoberturas);
    }
    verificaValorDeNovo() {
        if (!this.veiculoZero)
            this.coberturasService.desabilitaCampos(['valorDeNovo'], this.formCoberturas);
        else
            this.coberturasService.habilitaCampos(['valorDeNovo'], this.formCoberturas);
    }
    retornaPacotePadrao(pacotes) {
        var pacoteFiltrado = pacotes.filter(function (p) { return p.default; });
        pacoteFiltrado.pctAjuste = !pacoteFiltrado?.pctAjuste ? 100 : pacoteFiltrado.pctAjuste;
        return pacoteFiltrado?.length > 0 ? pacoteFiltrado[0] : false;
    }
    setaSelectsOptions(aplicacaoId) {
        this.selects.tipoCobertura = ConstantCoberturasAuto.tipoCobertura[aplicacaoId];
    }
    setaCoberturaPersonalizada() {
        this.formCoberturas.controls.tipoCobertura.setValue(CoberturasAutoService.buscaValue(this.selects.tipoCobertura, 'Personalizada'));
    }
    setaValores(version) {
        if (version) {
            this.calculo = version?.calculos[0];
            this.calculo.pctAjuste = version?.automoveis[0]?.pctAjuste || 100;
            if (!this.calculo?.isBlindagemValor && this.tipoVeiculo == 'v')
                this.calculo.isBlindagemValor = 0;
            this.setaValoresCampos(this.calculo);
        }
        else {
            let pacotePadrao = this.retornaPacotePadrao(this.coberturas);
            pacotePadrao.pctAjuste = pacotePadrao.pctAjuste || 100;
            if (!pacotePadrao?.isBlindagemValor && this.tipoVeiculo == 'v')
                pacotePadrao.isBlindagemValor = 0;
            this.setaValoresCampos(pacotePadrao);
        }
        this.verificaCoberturas();
    }
    setaValoresCampos(arrayCoberturas) {
        Object.keys(arrayCoberturas).forEach(nomeCobertura => {
            this.formCoberturas.controls[nomeCobertura] && this.formCoberturas.controls[nomeCobertura].setValue(this.formataValores(nomeCobertura, arrayCoberturas[nomeCobertura]));
        });
    }
    formataValores(nomeCampo, valor) {
        switch (nomeCampo) {
            case 'valorDeNovo':
                return typeof (valor) === 'number' ? valor : 0;
            case 'carroReservaAr':
            case 'despesasExtra':
            case 'rouboFurtoEstepe':
            case 'reparoRapido':
            case 'martelinhoOuro':
            case 'higienizacao':
            case 'vidros':
            case 'farolRetrovis':
            case 'tetoSolar':
            case 'lantFarolAux':
                return !!valor;
            default:
                return valor;
        }
    }
    openSnackbarModal(message) {
        const snackbarConfigs = {
            message,
            action: 'Fechar',
            cssClasses: ['snackbar', 'red-snackbar'],
            duration: 4000,
            horizontalPosition: 'center'
        };
        const config = new MatSnackBarConfig();
        config.panelClass = snackbarConfigs.cssClasses;
        config.duration = snackbarConfigs.duration;
        this._snackBar.open(snackbarConfigs.message, snackbarConfigs.action, config);
    }
    clicaBotaoSubmit() {
        try {
            document.getElementById('submitFormCoberturasAuto').click();
        }
        catch (error) {
            return false;
        }
    }
    static ɵfac = function CoberturasAutoComponent_Factory(t) { return new (t || CoberturasAutoComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(CoberturasAutoService), i0.ɵɵdirectiveInject(i3.MatSnackBar), i0.ɵɵdirectiveInject(IconsService), i0.ɵɵdirectiveInject('ajuste-por-seguradora-service'), i0.ɵɵdirectiveInject('cotacao-auto-service')); };
    static ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CoberturasAutoComponent, selectors: [["lib-coberturas-auto"]], inputs: { listaCampo: "listaCampo" }, outputs: { matStepRouteEvent: "matStepRouteEvent" }, decls: 120, vars: 78, consts: [[1, "container-coberturas"], [1, "card-coberturas"], [1, "container-title"], [4, "ngIf"], [1, "container-form"], [1, "form-coberturas", 3, "formGroup"], [1, "col-12", "container-tipo-cobertura", 3, "hidden"], [3, "ngClass"], ["formControlName", "tipoCobertura", "name", "tipoCobertura", 3, "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], [1, "col-12", "container-coberturas-auto"], [3, "hidden", "ngClass"], ["name", "tpCobertura", 3, "selectionChange", "formControl"], ["formControlName", "tipoFranquia", "name", "tipoFranquia", 3, "selectionChange"], ["formControlName", "pctAjuste", "name", "pctAjuste", 3, "selectionChange"], ["formControlName", "valorDeNovo", "name", "valorDeNovo", 3, "selectionChange"], ["formControlName", "isDanosMateriais", "name", "isDanosMateriais", 3, "selectionChange"], ["formControlName", "isDanosCorporais", "name", "isDanosCorporais", 3, "selectionChange"], ["formControlName", "isDanosMorais", "name", "isDanosMorais", 3, "selectionChange"], ["formControlName", "isAppMorte", "name", "isAppMorte", 3, "selectionChange"], ["formControlName", "isAppInvalidez", "name", "isAppInvalidez", 3, "selectionChange"], [3, "hidden", "ngClass", 4, "ngIf"], ["formControlName", "despesasExtra", "name", "despesasExtra", 3, "selectionChange"], ["formControlName", "guinchoKm", "name", "guinchoKm", 3, "selectionChange"], ["formControlName", "protecaoPneuRodas", "name", "protecaoPneuRodas", 3, "selectionChange"], ["formControlName", "reparoRapido", "name", "reparoRapido", 3, "selectionChange"], ["formControlName", "martelinhoOuro", "name", "martelinhoOuro", 3, "selectionChange"], ["formControlName", "higienizacao", "name", "higienizacao", 3, "selectionChange"], ["formControlName", "farolRetrovis", "name", "farolRetrovis", 3, "selectionChange"], ["formControlName", "lantFarolAux", "name", "lantFarolAux", 3, "selectionChange"], ["tabindex", "-1", "id", "submitFormCoberturasAuto", 2, "opacity", "0", "position", "absolute", "z-index", "-1000"], ["class", "container-botoes", 4, "ngIf"], [3, "value"], ["formControlName", "isBlindagemValor", "name", "isBlindagemValor", 3, "selectionChange"], ["formControlName", "carroReserva", "name", "carroReserva", 3, "selectionChange"], ["formControlName", "carroReservaAr", "name", "carroReservaAr", 3, "selectionChange"], ["formControlName", "vidros", "name", "vidros", 3, "selectionChange"], ["formControlName", "tetoSolar", "name", "tetoSolar", 3, "selectionChange"], [1, "container-botoes"], [1, "container-botoes-calculo"], ["name", "btn-voltar", "mat-stroked-button", "", "matTooltip", "VOLTAR PARA O FORMUL\u00C1RIO", 1, "btn-voltar", 3, "click", "matTooltipPosition"], [1, "text-btn"], ["name", "btn-calcular", "mat-flat-button", "", "color", "primary", "class", "btn-calcular", 3, "matTooltip", "matTooltipPosition", "click", 4, "ngIf"], ["mat-flat-button", "", "color", "primary", "class", "btn-proximo", "matTooltip", "AJUSTES POR SEGURADORA", 3, "matTooltipPosition", "click", 4, "ngIf"], ["class", "container-btn-ajuste-por-seguradora", 4, "ngIf"], ["name", "btn-calcular", "mat-flat-button", "", "color", "primary", 1, "btn-calcular", 3, "click", "matTooltip", "matTooltipPosition"], ["mat-flat-button", "", "color", "primary", "matTooltip", "AJUSTES POR SEGURADORA", 1, "btn-proximo", 3, "click", "matTooltipPosition"], [1, "container-btn-ajuste-por-seguradora"], ["name", "btn-ajuste-por-seguradora", "mat-button", "", 1, "btn-ajuste-por-seguradora", 3, "click"], [1, "container-text-btn-ajuste-por-seguradora"], [3, "svgIcon"], [1, "text"]], template: function CoberturasAutoComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "mat-card", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, CoberturasAutoComponent_h2_3_Template, 2, 0, "h2", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4)(5, "form", 5)(6, "div", 6)(7, "mat-form-field", 7)(8, "mat-label");
            i0.ɵɵtext(9, "Selecione o pacote de coberturas");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "mat-select", 8);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_10_listener($event) { return ctx.changeCobertura($event.value); });
            i0.ɵɵtemplate(11, CoberturasAutoComponent_mat_option_11_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, CoberturasAutoComponent_mat_error_12_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(13, "div", 10)(14, "mat-form-field", 11)(15, "mat-label");
            i0.ɵɵtext(16, "Tipo de Cobertura");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "mat-select", 12);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_17_listener() { return ctx.verificaCoberturas(); });
            i0.ɵɵtemplate(18, CoberturasAutoComponent_mat_option_18_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(19, "mat-form-field", 11)(20, "mat-label");
            i0.ɵɵtext(21, "Franquia");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(22, "mat-select", 13);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_22_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(23, CoberturasAutoComponent_mat_option_23_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(24, CoberturasAutoComponent_mat_error_24_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(25, "mat-form-field", 11)(26, "mat-label");
            i0.ɵɵtext(27, "Fipe (%)");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(28, "mat-select", 14);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_28_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(29, CoberturasAutoComponent_mat_option_29_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(30, CoberturasAutoComponent_mat_error_30_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "mat-form-field", 11)(32, "mat-label");
            i0.ɵɵtext(33, "Valor Novo");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(34, "mat-select", 15);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_34_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(35, CoberturasAutoComponent_mat_option_35_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(36, "mat-form-field", 11)(37, "mat-label");
            i0.ɵɵtext(38, "Danos materiais");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(39, "mat-select", 16);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_39_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(40, CoberturasAutoComponent_mat_option_40_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(41, CoberturasAutoComponent_mat_error_41_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(42, "mat-form-field", 11)(43, "mat-label");
            i0.ɵɵtext(44, "Danos corporais");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(45, "mat-select", 17);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_45_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(46, CoberturasAutoComponent_mat_option_46_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(47, CoberturasAutoComponent_mat_error_47_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(48, "mat-form-field", 11)(49, "mat-label");
            i0.ɵɵtext(50, "Danos morais");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(51, "mat-select", 18);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_51_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(52, CoberturasAutoComponent_mat_option_52_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(53, CoberturasAutoComponent_mat_error_53_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(54, "mat-form-field", 11)(55, "mat-label");
            i0.ɵɵtext(56, "App Morte");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(57, "mat-select", 19);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_57_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(58, CoberturasAutoComponent_mat_option_58_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(59, CoberturasAutoComponent_mat_error_59_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(60, "mat-form-field", 11)(61, "mat-label");
            i0.ɵɵtext(62, "App Invalidez");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(63, "mat-select", 20);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_63_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(64, CoberturasAutoComponent_mat_option_64_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(65, CoberturasAutoComponent_mat_error_65_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(66, CoberturasAutoComponent_mat_form_field_66_Template, 5, 3, "mat-form-field", 21)(67, CoberturasAutoComponent_mat_form_field_67_Template, 6, 4, "mat-form-field", 21)(68, CoberturasAutoComponent_mat_form_field_68_Template, 6, 4, "mat-form-field", 21);
            i0.ɵɵelementStart(69, "mat-form-field", 11)(70, "mat-label");
            i0.ɵɵtext(71, "Despesas Extra");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(72, "mat-select", 22);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_72_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(73, CoberturasAutoComponent_mat_option_73_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(74, CoberturasAutoComponent_mat_error_74_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(75, "mat-form-field", 11)(76, "mat-label");
            i0.ɵɵtext(77, "Guincho KM");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(78, "mat-select", 23);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_78_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(79, CoberturasAutoComponent_mat_option_79_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(80, CoberturasAutoComponent_mat_error_80_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(81, "mat-form-field", 11)(82, "mat-label");
            i0.ɵɵtext(83, "Prote\u00E7\u00E3o Pneu e Rodas");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(84, "mat-select", 24);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_84_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(85, CoberturasAutoComponent_mat_option_85_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(86, CoberturasAutoComponent_mat_error_86_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(87, "mat-form-field", 11)(88, "mat-label");
            i0.ɵɵtext(89, "Reparo R\u00E1pido");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(90, "mat-select", 25);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_90_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(91, CoberturasAutoComponent_mat_option_91_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(92, CoberturasAutoComponent_mat_error_92_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(93, "mat-form-field", 11)(94, "mat-label");
            i0.ɵɵtext(95, "Martelinho de Ouro");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(96, "mat-select", 26);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_96_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(97, CoberturasAutoComponent_mat_option_97_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(98, CoberturasAutoComponent_mat_error_98_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(99, "mat-form-field", 11)(100, "mat-label");
            i0.ɵɵtext(101, "Higieniza\u00E7\u00E3o");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(102, "mat-select", 27);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_102_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(103, CoberturasAutoComponent_mat_option_103_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(104, CoberturasAutoComponent_mat_error_104_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(105, CoberturasAutoComponent_mat_form_field_105_Template, 6, 4, "mat-form-field", 21);
            i0.ɵɵelementStart(106, "mat-form-field", 11)(107, "mat-label");
            i0.ɵɵtext(108, "Farol retrovisor");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(109, "mat-select", 28);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_109_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(110, CoberturasAutoComponent_mat_option_110_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(111, CoberturasAutoComponent_mat_error_111_Template, 2, 0, "mat-error", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(112, CoberturasAutoComponent_mat_form_field_112_Template, 5, 3, "mat-form-field", 21);
            i0.ɵɵelementStart(113, "mat-form-field", 11)(114, "mat-label");
            i0.ɵɵtext(115, "Lanterna Farol Auxiliar");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(116, "mat-select", 29);
            i0.ɵɵlistener("selectionChange", function CoberturasAutoComponent_Template_mat_select_selectionChange_116_listener() { return ctx.setaCoberturaPersonalizada(); });
            i0.ɵɵtemplate(117, CoberturasAutoComponent_mat_option_117_Template, 2, 3, "mat-option", 9);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(118, "button", 30);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(119, CoberturasAutoComponent_div_119_Template, 8, 4, "div", 31);
            i0.ɵɵelementEnd()();
        } if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.isRecalculo);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formGroup", ctx.formCoberturas);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_PACOTE));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", !ctx.isRecalculo ? "col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects == null ? null : ctx.selects.tipoCobertura);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("tipoCobertura").hasError("required"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.TPCOBERTURA))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formControl", ctx.tipoCobertura);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.selects.tpCobertura);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_TIPOFRANQUIA))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.tipoFranquia);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("tipoFranquia").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.AUTOMOVEIS_PCTAJUSTE))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.pctAjuste);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("pctAjuste").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_VALORNOVO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.valorDeNovo);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_ISDANOSMATERIAIS))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.isDanosMateriais);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("isDanosMateriais").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_ISDANOSCORPORAIS))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.isDanosCorporais);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("isDanosCorporais").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_ISDANOSMORAIS))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.isDanosMorais);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("isDanosMorais").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_ISAPPMORTE))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.isAppMorte);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("isAppMorte").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_ISAPPINVALIDEZ))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.isAppInvalidez);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("isAppInvalidez").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.tipoVeiculo == ctx.tiposDeVeiculo.CARRO);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.tipoVeiculo != ctx.tiposDeVeiculo.MOTOCICLETA);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.tipoVeiculo != ctx.tiposDeVeiculo.MOTOCICLETA);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_DESPESASEXTRAS))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.simOuNao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("despesasExtra").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_GUINCHOKM))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.guinchoKm);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("guinchoKm").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_PROTECAOPNEURODAS))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.simOuNao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("protecaoPneuRodas").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.REPARORAPIDO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.simOuNao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("reparoRapido").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_MARTELINHOOURO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.simOuNao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("martelinhoOuro").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_HIGIENIZACAO))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.simOuNao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("higienizacao").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.tipoVeiculo != ctx.tiposDeVeiculo.MOTOCICLETA);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_FAROLRETROVISOR))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.simOuNao);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.formCoberturas.get("farolRetrovis").hasError("required"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.tipoVeiculo != ctx.tiposDeVeiculo.MOTOCICLETA);
            i0.ɵɵadvance();
            i0.ɵɵproperty("hidden", ctx.isRecalculo && !(ctx.habCampos == null ? null : ctx.habCampos.CALCULOS_LATERNAFAROLAUCILIAR))("ngClass", !ctx.isRecalculo ? "col-12 col-md-6 col-lg-4 col-xl-3" : "col-12");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngForOf", ctx.selects.simOuNao);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", !ctx.isRecalculo);
        } }, dependencies: [i5.NgClass, i5.NgForOf, i5.NgIf, i1$1.ɵNgNoValidate, i1$1.NgControlStatus, i1$1.NgControlStatusGroup, i6.MatButton, i7.MatCard, i8.MatFormField, i8.MatLabel, i8.MatError, i9.MatSelect, i10.MatOption, i11.MatTooltip, i1.MatIcon, i1$1.FormControlDirective, i1$1.FormGroupDirective, i1$1.FormControlName], styles: [".container-coberturas[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]{width:100%;max-width:1140px;margin-top:10px;padding:24px}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-title[_ngcontent-%COMP%]{margin-bottom:0}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-title[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{color:var(--color-primary);font-weight:500;text-transform:uppercase;font-size:18px;letter-spacing:.5px;padding:0 22px;margin:0 0 10px!important}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-form[_ngcontent-%COMP%]{padding:0 15px}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-form[_ngcontent-%COMP%]   .container-tipo-cobertura[_ngcontent-%COMP%], .container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-form[_ngcontent-%COMP%]   .container-coberturas-auto[_ngcontent-%COMP%]{padding:0;margin-bottom:15px}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]{display:flex}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-botoes-calculo[_ngcontent-%COMP%]{width:calc(100% - 450px);display:flex;margin:0 0 0 225px;justify-content:center}@media (max-width: 480px){.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-botoes-calculo[_ngcontent-%COMP%]{gap:8px}}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-botoes-calculo[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{height:40px;padding:10px;border-radius:3px}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-botoes-calculo[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]   .text-btn[_ngcontent-%COMP%]{font-size:14px;line-height:normal}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-botoes-calculo[_ngcontent-%COMP%]   .btn-voltar[_ngcontent-%COMP%]{width:120px;background-color:transparent;border:1px solid #60616A}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-botoes-calculo[_ngcontent-%COMP%]   .btn-voltar[_ngcontent-%COMP%]   .text-btn[_ngcontent-%COMP%]{color:#60616a;font-weight:400;letter-spacing:normal}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-botoes-calculo[_ngcontent-%COMP%]   .btn-proximo[_ngcontent-%COMP%], .container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-botoes-calculo[_ngcontent-%COMP%]   .btn-calcular[_ngcontent-%COMP%]{width:164px;background-color:var(--color-tertiary-first)}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-botoes-calculo[_ngcontent-%COMP%]   .btn-proximo[_ngcontent-%COMP%]   .text-btn[_ngcontent-%COMP%], .container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-botoes-calculo[_ngcontent-%COMP%]   .btn-calcular[_ngcontent-%COMP%]   .text-btn[_ngcontent-%COMP%]{color:#fefefe;font-weight:500;letter-spacing:.42px}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-botoes-calculo[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{outline:none}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-btn-ajuste-por-seguradora[_ngcontent-%COMP%]{width:225px}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-btn-ajuste-por-seguradora[_ngcontent-%COMP%]   .btn-ajuste-por-seguradora[_ngcontent-%COMP%]{width:fit-content;background-color:transparent;color:var(--primary)}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-btn-ajuste-por-seguradora[_ngcontent-%COMP%]   .btn-ajuste-por-seguradora[_ngcontent-%COMP%]   .container-text-btn-ajuste-por-seguradora[_ngcontent-%COMP%]{display:flex;align-items:center;gap:8px}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-btn-ajuste-por-seguradora[_ngcontent-%COMP%]   .btn-ajuste-por-seguradora[_ngcontent-%COMP%]   .container-text-btn-ajuste-por-seguradora[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{display:flex;width:20px;height:20px}.container-coberturas[_ngcontent-%COMP%]   .card-coberturas[_ngcontent-%COMP%]   .container-botoes[_ngcontent-%COMP%]   .container-btn-ajuste-por-seguradora[_ngcontent-%COMP%]   .btn-ajuste-por-seguradora[_ngcontent-%COMP%]   .container-text-btn-ajuste-por-seguradora[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{text-decoration:underline}.container-coberturas[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{outline:none}  .container-coberturas .mat-mdc-form-field{font-weight:500;letter-spacing:normal;color:#0000008a;padding:0 7px;height:38px;display:inline-block;position:relative;text-align:left}  .container-coberturas .container-form-auto .mdc-text-field--filled:not(.mdc-text-field--disabled){height:38px}  .container-coberturas .mat-mdc-form-field-hint-wrapper,   .container-coberturas .mat-mdc-form-field-error-wrapper{padding:0;top:-2px}  .container-coberturas .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mdc-floating-label--float-above{top:16px!important}  .container-coberturas .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-floating-label{top:23px;letter-spacing:normal;line-height:15.75px;color:var(--color-dark)}  .container-coberturas .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input{color:var(--color-dark);font-size:14px;font-weight:400;height:46px}  .container-coberturas .mdc-text-field .mdc-text-field__input{font-size:14px;font-weight:400;height:46px}  .container-coberturas .mdc-text-field--disabled .mdc-line-ripple{display:none}  .container-coberturas .mat-form-field-disabled .mat-mdc-form-field-hint-wrapper{background-image:linear-gradient(90deg,rgba(0,0,0,.42) 0,rgba(0,0,0,.42) 33%,transparent 0);background-size:4px 100%;background-repeat:repeat-x;height:1px}  .container-coberturas .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--color-primary)}  .container-coberturas .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--mdc-theme-error, #f44336)!important}  .container-coberturas .mat-mdc-form-field.mat-focused.mat-warn .mat-mdc-select-arrow,   .container-coberturas .mat-mdc-form-field .mat-mdc-select.mat-mdc-select-invalid .mat-mdc-select-arrow{color:var(--mdc-theme-error, #f44336)!important}  .container-coberturas .mat-mdc-form-field-error{font-size:10.5px;line-height:10.5px;letter-spacing:normal}  .container-coberturas .mat-form-field-appearance-fill .mat-mdc-select-arrow-wrapper{transform:translateY(0)}  .container-coberturas .mat-mdc-select-trigger{font-size:14px}  .container-coberturas .mdc-text-field--filled{background-color:transparent!important;padding:0;height:38px}  .container-coberturas .mat-mdc-form-field-focus-overlay{background-color:transparent}  .container-coberturas .mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix{padding-top:0;padding-bottom:0}  .container-coberturas .mat-mdc-form-field-infix{min-height:38px}  .container-coberturas .mat-mdc-select-trigger{height:48px}  .container-coberturas .mat-mdc-form-field-subscript-wrapper{box-sizing:border-box;width:100%;position:relative;height:17.5px}  .container-coberturas .mdc-floating-label{font-size:14px;color:var(--color-dark)}  .container-coberturas .mdc-text-field .mdc-text-field__input{caret-color:var(--color-primary)}  .container-coberturas .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}  .container-coberturas .mdc-text-field--filled:not(.mdc-text-field--invalid) .mdc-line-ripple:after{border-bottom-color:var(--color-primary)}  .container-coberturas .mat-mdc-form-field.mat-focused.mat-primary .mat-mdc-select-arrow{color:var(--color-primary)}  .container-coberturas .mat-mdc-progress-spinner{--mdc-circular-progress-active-indicator-color: var(--color-primary)}  .container-coberturas .mdc-text-field--invalid .mdc-text-field__input{caret-color:var(--mdc-theme-error, #f44336)}  .container-coberturas .mdc-text-field--disabled.mdc-text-field--filled{background-color:transparent}  .container-coberturas .mat-mdc-checkbox.mat-accent{--mdc-checkbox-selected-checkmark-color: #fff;--mdc-checkbox-selected-focus-icon-color: var(--color-primary);--mdc-checkbox-selected-hover-icon-color: var(--color-primary);--mdc-checkbox-selected-icon-color: var(--color-primary);--mdc-checkbox-selected-pressed-icon-color: var(--color-primary);--mdc-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-disabled-selected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-disabled-unselected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-pressed-icon-color: rgba(0, 0, 0, .54)}  .container-coberturas .mat-mdc-checkbox.mat-accent .mdc-checkbox__ripple{background:var(--color-secundary)}  .mat-primary .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text{color:var(--color-primary)}  .mat-mdc-option .mdc-list-item__primary-text{font-size:14px!important}  .mdc-tooltip__surface{font-size:10px!important}@media screen and (max-width: 850px){.container-botoes[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;gap:8px;flex-wrap:wrap}.container-botoes[_ngcontent-%COMP%]   .container-botoes-calculo[_ngcontent-%COMP%]{width:fit-content;display:flex;align-items:baseline;margin:0;justify-content:center;gap:8px}.container-botoes[_ngcontent-%COMP%]   .container-btn-ajuste-por-seguradora[_ngcontent-%COMP%]{width:fit-content;align-items:center;display:flex}}"] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CoberturasAutoComponent, [{
        type: Component,
        args: [{ selector: 'lib-coberturas-auto', template: "<div class=\"container-coberturas\">\r\n  <mat-card class=\"card-coberturas\">\r\n    <div class=\"container-title\">\r\n      <h2 *ngIf=\"!isRecalculo\">Pacotes e coberturas</h2>\r\n      <!-- <h2 *ngIf=\"isRecalculo\">coberturas</h2> -->\r\n    </div>\r\n    <div class=\"container-form\">\r\n      <form class=\"form-coberturas\" [formGroup]=\"formCoberturas\">\r\n\r\n\r\n        <div [hidden]=\"isRecalculo && !habCampos?.CALCULOS_PACOTE\" class=\"col-12 container-tipo-cobertura\">\r\n\r\n          <mat-form-field [ngClass]=\"!isRecalculo ? 'col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Selecione o pacote de coberturas</mat-label>\r\n            <mat-select formControlName=\"tipoCobertura\" name=\"tipoCobertura\" (selectionChange)=\"changeCobertura($event.value)\">\r\n              <mat-option *ngFor=\"let v of selects?.tipoCobertura\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('tipoCobertura').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n        </div>\r\n        <div class=\"col-12 container-coberturas-auto\">\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.TPCOBERTURA\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Tipo de Cobertura</mat-label>\r\n            <mat-select [formControl]=\"tipoCobertura\" name=\"tpCobertura\" (selectionChange)=\"verificaCoberturas()\">\r\n              <mat-option *ngFor=\"let v of selects.tpCobertura\" [value]=\"v.value\"\r\n                [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_TIPOFRANQUIA\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Franquia</mat-label>\r\n            <mat-select formControlName=\"tipoFranquia\" name=\"tipoFranquia\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.tipoFranquia\" [value]=\"v.value\"\r\n                [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('tipoFranquia').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.AUTOMOVEIS_PCTAJUSTE\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Fipe (%)</mat-label>\r\n            <mat-select formControlName=\"pctAjuste\" name=\"pctAjuste\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.pctAjuste\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('pctAjuste').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_VALORNOVO\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Valor Novo</mat-label>\r\n            <mat-select formControlName=\"valorDeNovo\" name=\"valorDeNovo\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.valorDeNovo\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_ISDANOSMATERIAIS\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Danos materiais</mat-label>\r\n            <mat-select formControlName=\"isDanosMateriais\" name=\"isDanosMateriais\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.isDanosMateriais\" [value]=\"v.value\"\r\n                [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('isDanosMateriais').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_ISDANOSCORPORAIS\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Danos corporais</mat-label>\r\n            <mat-select formControlName=\"isDanosCorporais\" name=\"isDanosCorporais\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.isDanosCorporais\" [value]=\"v.value\"\r\n                [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('isDanosCorporais').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_ISDANOSMORAIS\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Danos morais</mat-label>\r\n            <mat-select formControlName=\"isDanosMorais\" name=\"isDanosMorais\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.isDanosMorais\" [value]=\"v.value\"\r\n                [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('isDanosMorais').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_ISAPPMORTE\"   [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>App Morte</mat-label>\r\n            <mat-select formControlName=\"isAppMorte\" name=\"isAppMorte\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.isAppMorte\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('isAppMorte').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_ISAPPINVALIDEZ\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>App Invalidez</mat-label>\r\n            <mat-select formControlName=\"isAppInvalidez\" name=\"isAppInvalidez\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.isAppInvalidez\" [value]=\"v.value\"\r\n                [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('isAppInvalidez').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_BLINDAGEM\" *ngIf=\"tipoVeiculo == tiposDeVeiculo.CARRO\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-6 col-xl-3' : 'col-12'\">\r\n            <mat-label>Blindagem</mat-label>\r\n            <mat-select formControlName=\"isBlindagemValor\" name=\"isBlindagemValor\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let b of selects.blindagem\" [value]=\"b.value\" [attr.custom-reflect-value]=\"b.value\">\r\n                {{ b.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_CARRORESERVA\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\" *ngIf=\"tipoVeiculo != tiposDeVeiculo.MOTOCICLETA\">\r\n            <mat-label>Carro Reserva</mat-label>\r\n            <mat-select formControlName=\"carroReserva\" name=\"carroReserva\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.carroReserva\" [value]=\"v.value\"\r\n                [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('carroReserva').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_CARRORESERVA\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\" *ngIf=\"tipoVeiculo != tiposDeVeiculo.MOTOCICLETA\">\r\n            <mat-label>Carro Reserva c/ Ar</mat-label>\r\n            <mat-select formControlName=\"carroReservaAr\" name=\"carroReservaAr\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('carroReservaAr').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_DESPESASEXTRAS\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Despesas Extra</mat-label>\r\n            <mat-select formControlName=\"despesasExtra\" name=\"despesasExtra\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('despesasExtra').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_GUINCHOKM\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Guincho KM</mat-label>\r\n            <mat-select formControlName=\"guinchoKm\" name=\"guinchoKm\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.guinchoKm\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('guinchoKm').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_PROTECAOPNEURODAS\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Prote\u00E7\u00E3o Pneu e Rodas</mat-label>\r\n            <mat-select formControlName=\"protecaoPneuRodas\" name=\"protecaoPneuRodas\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('protecaoPneuRodas').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.REPARORAPIDO\"  [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Reparo R\u00E1pido</mat-label>\r\n            <mat-select formControlName=\"reparoRapido\" name=\"reparoRapido\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('reparoRapido').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_MARTELINHOOURO\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Martelinho de Ouro</mat-label>\r\n            <mat-select formControlName=\"martelinhoOuro\" name=\"martelinhoOuro\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('martelinhoOuro').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field  [hidden]=\"isRecalculo && !habCampos?.CALCULOS_HIGIENIZACAO\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Higieniza\u00E7\u00E3o</mat-label>\r\n            <mat-select formControlName=\"higienizacao\" name=\"higienizacao\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('higienizacao').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_VIDROS\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\" *ngIf=\"tipoVeiculo != tiposDeVeiculo.MOTOCICLETA\">\r\n            <mat-label>Vidros</mat-label>\r\n            <mat-select formControlName=\"vidros\" name=\"vidros\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('vidros').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_FAROLRETROVISOR\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Farol retrovisor</mat-label>\r\n            <mat-select formControlName=\"farolRetrovis\" name=\"farolRetrovis\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n            <mat-error *ngIf=\"formCoberturas.get('farolRetrovis').hasError('required')\">Por favor, selecione uma op\u00E7\u00E3o.</mat-error>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_TETOSOLAR\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\" *ngIf=\"tipoVeiculo != tiposDeVeiculo.MOTOCICLETA\">\r\n            <mat-label>Teto Solar</mat-label>\r\n            <mat-select formControlName=\"tetoSolar\" name=\"tetoSolar\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n          </mat-form-field>\r\n\r\n          <mat-form-field [hidden]=\"isRecalculo && !habCampos?.CALCULOS_LATERNAFAROLAUCILIAR\" [ngClass]=\"!isRecalculo ? 'col-12 col-md-6 col-lg-4 col-xl-3' : 'col-12'\">\r\n            <mat-label>Lanterna Farol Auxiliar</mat-label>\r\n            <mat-select formControlName=\"lantFarolAux\" name=\"lantFarolAux\" (selectionChange)=\"setaCoberturaPersonalizada()\">\r\n              <mat-option *ngFor=\"let v of selects.simOuNao\" [value]=\"v.value\" [attr.custom-reflect-value]=\"v.value\">\r\n                {{ v.viewValue }}\r\n              </mat-option>\r\n            </mat-select>\r\n          </mat-form-field>\r\n\r\n        </div>\r\n        <button tabindex=\"-1\" id=\"submitFormCoberturasAuto\" style=\"opacity: 0; position: absolute; z-index: -1000\"></button>\r\n      </form>\r\n    </div>\r\n    <div class=\"container-botoes\"  *ngIf=\"!isRecalculo\">\r\n      <div class=\"container-botoes-calculo\">\r\n        <button name=\"btn-voltar\" mat-stroked-button class=\"btn-voltar\" (click)=\"matStepRoute('previous')\"\r\n          matTooltip=\"VOLTAR PARA O FORMUL\u00C1RIO\" [matTooltipPosition]=\"'left'\">\r\n          <span class=\"text-btn\">VOLTAR</span>\r\n        </button>\r\n        <button name=\"btn-calcular\" mat-flat-button color=\"primary\" class=\"btn-calcular\" (click)=\"matStepRoute('next')\"\r\n          [matTooltip]=\"'ENVIAR PARA CALCULO'\" [matTooltipPosition]=\"'right'\"\r\n          *ngIf=\"!possuiAjustePorSeguradora || !ajustePorSeguradoraDisponivel\">\r\n          <span class=\"text-btn\">CALCULAR</span>\r\n        </button>\r\n        <button *ngIf=\"possuiAjustePorSeguradora && ajustePorSeguradoraDisponivel && tipoVeiculo === 'v'\" mat-flat-button\r\n          color=\"primary\" class=\"btn-proximo\" (click)=\"matStepRoute('ajuste')\" matTooltip=\"AJUSTES POR SEGURADORA\"\r\n          [matTooltipPosition]=\"'right'\">\r\n          <span class=\"text-btn\">PR\u00D3XIMO</span>\r\n        </button>\r\n        </div>\r\n        <div class=\"container-btn-ajuste-por-seguradora\" *ngIf=\"ajustePorSeguradoraDisponivel && tipoVeiculo === 'v'\">\r\n          <button name=\"btn-ajuste-por-seguradora\" mat-button (click)=\"matStepRoute('ajuste')\"\r\n            class=\"btn-ajuste-por-seguradora\">\r\n            <div class=\"container-text-btn-ajuste-por-seguradora\">\r\n              <mat-icon [svgIcon]=\"'cogs'\"></mat-icon>\r\n              <span class=\"text\">Ajustes por seguradora</span>\r\n            </div>\r\n          </button>\r\n        </div>\r\n    </div>\r\n  </mat-card>\r\n</div>\r\n", styles: [".container-coberturas{display:flex;align-items:center;justify-content:center}.container-coberturas .card-coberturas{width:100%;max-width:1140px;margin-top:10px;padding:24px}.container-coberturas .card-coberturas .container-title{margin-bottom:0}.container-coberturas .card-coberturas .container-title h2{color:var(--color-primary);font-weight:500;text-transform:uppercase;font-size:18px;letter-spacing:.5px;padding:0 22px;margin:0 0 10px!important}.container-coberturas .card-coberturas .container-form{padding:0 15px}.container-coberturas .card-coberturas .container-form .container-tipo-cobertura,.container-coberturas .card-coberturas .container-form .container-coberturas-auto{padding:0;margin-bottom:15px}.container-coberturas .card-coberturas .container-botoes{display:flex}.container-coberturas .card-coberturas .container-botoes .container-botoes-calculo{width:calc(100% - 450px);display:flex;margin:0 0 0 225px;justify-content:center}@media (max-width: 480px){.container-coberturas .card-coberturas .container-botoes .container-botoes-calculo{gap:8px}}.container-coberturas .card-coberturas .container-botoes .container-botoes-calculo button{height:40px;padding:10px;border-radius:3px}.container-coberturas .card-coberturas .container-botoes .container-botoes-calculo button .text-btn{font-size:14px;line-height:normal}.container-coberturas .card-coberturas .container-botoes .container-botoes-calculo .btn-voltar{width:120px;background-color:transparent;border:1px solid #60616A}.container-coberturas .card-coberturas .container-botoes .container-botoes-calculo .btn-voltar .text-btn{color:#60616a;font-weight:400;letter-spacing:normal}.container-coberturas .card-coberturas .container-botoes .container-botoes-calculo .btn-proximo,.container-coberturas .card-coberturas .container-botoes .container-botoes-calculo .btn-calcular{width:164px;background-color:var(--color-tertiary-first)}.container-coberturas .card-coberturas .container-botoes .container-botoes-calculo .btn-proximo .text-btn,.container-coberturas .card-coberturas .container-botoes .container-botoes-calculo .btn-calcular .text-btn{color:#fefefe;font-weight:500;letter-spacing:.42px}.container-coberturas .card-coberturas .container-botoes .container-botoes-calculo button:focus{outline:none}.container-coberturas .card-coberturas .container-botoes .container-btn-ajuste-por-seguradora{width:225px}.container-coberturas .card-coberturas .container-botoes .container-btn-ajuste-por-seguradora .btn-ajuste-por-seguradora{width:fit-content;background-color:transparent;color:var(--primary)}.container-coberturas .card-coberturas .container-botoes .container-btn-ajuste-por-seguradora .btn-ajuste-por-seguradora .container-text-btn-ajuste-por-seguradora{display:flex;align-items:center;gap:8px}.container-coberturas .card-coberturas .container-botoes .container-btn-ajuste-por-seguradora .btn-ajuste-por-seguradora .container-text-btn-ajuste-por-seguradora .mat-icon{display:flex;width:20px;height:20px}.container-coberturas .card-coberturas .container-botoes .container-btn-ajuste-por-seguradora .btn-ajuste-por-seguradora .container-text-btn-ajuste-por-seguradora .text{text-decoration:underline}.container-coberturas button:focus{outline:none}::ng-deep .container-coberturas .mat-mdc-form-field{font-weight:500;letter-spacing:normal;color:#0000008a;padding:0 7px;height:38px;display:inline-block;position:relative;text-align:left}::ng-deep .container-coberturas .container-form-auto .mdc-text-field--filled:not(.mdc-text-field--disabled){height:38px}::ng-deep .container-coberturas .mat-mdc-form-field-hint-wrapper,::ng-deep .container-coberturas .mat-mdc-form-field-error-wrapper{padding:0;top:-2px}::ng-deep .container-coberturas .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mdc-floating-label--float-above{top:16px!important}::ng-deep .container-coberturas .mat-mdc-text-field-wrapper .mat-mdc-form-field-infix .mat-mdc-floating-label{top:23px;letter-spacing:normal;line-height:15.75px;color:var(--color-dark)}::ng-deep .container-coberturas .mdc-text-field:not(.mdc-text-field--disabled) .mdc-text-field__input{color:var(--color-dark);font-size:14px;font-weight:400;height:46px}::ng-deep .container-coberturas .mdc-text-field .mdc-text-field__input{font-size:14px;font-weight:400;height:46px}::ng-deep .container-coberturas .mdc-text-field--disabled .mdc-line-ripple{display:none}::ng-deep .container-coberturas .mat-form-field-disabled .mat-mdc-form-field-hint-wrapper{background-image:linear-gradient(90deg,rgba(0,0,0,.42) 0,rgba(0,0,0,.42) 33%,transparent 0);background-size:4px 100%;background-repeat:repeat-x;height:1px}::ng-deep .container-coberturas .mdc-text-field--focused:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--color-primary)}::ng-deep .container-coberturas .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-floating-label{color:var(--mdc-theme-error, #f44336)!important}::ng-deep .container-coberturas .mat-mdc-form-field.mat-focused.mat-warn .mat-mdc-select-arrow,::ng-deep .container-coberturas .mat-mdc-form-field .mat-mdc-select.mat-mdc-select-invalid .mat-mdc-select-arrow{color:var(--mdc-theme-error, #f44336)!important}::ng-deep .container-coberturas .mat-mdc-form-field-error{font-size:10.5px;line-height:10.5px;letter-spacing:normal}::ng-deep .container-coberturas .mat-form-field-appearance-fill .mat-mdc-select-arrow-wrapper{transform:translateY(0)}::ng-deep .container-coberturas .mat-mdc-select-trigger{font-size:14px}::ng-deep .container-coberturas .mdc-text-field--filled{background-color:transparent!important;padding:0;height:38px}::ng-deep .container-coberturas .mat-mdc-form-field-focus-overlay{background-color:transparent}::ng-deep .container-coberturas .mat-mdc-text-field-wrapper:not(.mdc-text-field--outlined) .mat-mdc-form-field-infix{padding-top:0;padding-bottom:0}::ng-deep .container-coberturas .mat-mdc-form-field-infix{min-height:38px}::ng-deep .container-coberturas .mat-mdc-select-trigger{height:48px}::ng-deep .container-coberturas .mat-mdc-form-field-subscript-wrapper{box-sizing:border-box;width:100%;position:relative;height:17.5px}::ng-deep .container-coberturas .mdc-floating-label{font-size:14px;color:var(--color-dark)}::ng-deep .container-coberturas .mdc-text-field .mdc-text-field__input{caret-color:var(--color-primary)}::ng-deep .container-coberturas .mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-line-ripple:before{border-bottom-color:var(--mdc-theme-error, #f44336)}::ng-deep .container-coberturas .mdc-text-field--filled:not(.mdc-text-field--invalid) .mdc-line-ripple:after{border-bottom-color:var(--color-primary)}::ng-deep .container-coberturas .mat-mdc-form-field.mat-focused.mat-primary .mat-mdc-select-arrow{color:var(--color-primary)}::ng-deep .container-coberturas .mat-mdc-progress-spinner{--mdc-circular-progress-active-indicator-color: var(--color-primary)}::ng-deep .container-coberturas .mdc-text-field--invalid .mdc-text-field__input{caret-color:var(--mdc-theme-error, #f44336)}::ng-deep .container-coberturas .mdc-text-field--disabled.mdc-text-field--filled{background-color:transparent}::ng-deep .container-coberturas .mat-mdc-checkbox.mat-accent{--mdc-checkbox-selected-checkmark-color: #fff;--mdc-checkbox-selected-focus-icon-color: var(--color-primary);--mdc-checkbox-selected-hover-icon-color: var(--color-primary);--mdc-checkbox-selected-icon-color: var(--color-primary);--mdc-checkbox-selected-pressed-icon-color: var(--color-primary);--mdc-checkbox-unselected-focus-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-hover-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-disabled-selected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-disabled-unselected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-icon-color: rgba(0, 0, 0, .54);--mdc-checkbox-unselected-pressed-icon-color: rgba(0, 0, 0, .54)}::ng-deep .container-coberturas .mat-mdc-checkbox.mat-accent .mdc-checkbox__ripple{background:var(--color-secundary)}::ng-deep .mat-primary .mat-mdc-option.mdc-list-item--selected:not(.mdc-list-item--disabled) .mdc-list-item__primary-text{color:var(--color-primary)}::ng-deep .mat-mdc-option .mdc-list-item__primary-text{font-size:14px!important}::ng-deep .mdc-tooltip__surface{font-size:10px!important}@media screen and (max-width: 850px){.container-botoes{display:flex;justify-content:center;align-items:center;gap:8px;flex-wrap:wrap}.container-botoes .container-botoes-calculo{width:fit-content;display:flex;align-items:baseline;margin:0;justify-content:center;gap:8px}.container-botoes .container-btn-ajuste-por-seguradora{width:fit-content;align-items:center;display:flex}}\n"] }]
    }], () => [{ type: i1$1.FormBuilder }, { type: CoberturasAutoService }, { type: i3.MatSnackBar }, { type: IconsService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['ajuste-por-seguradora-service']
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: ['cotacao-auto-service']
            }] }], { matStepRouteEvent: [{
            type: Output
        }], listaCampo: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(CoberturasAutoComponent, { className: "CoberturasAutoComponent", filePath: "lib\\coberturas-auto.component.ts", lineNumber: 12 }); })();

class LibCoberturasAutoModule {
    static ɵfac = function LibCoberturasAutoModule_Factory(t) { return new (t || LibCoberturasAutoModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: LibCoberturasAutoModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [IconsService], imports: [CommonModule,
            FormsModule,
            MatButtonModule,
            MatCardModule,
            MatInputModule,
            MatSelectModule,
            MatSnackBarModule,
            MatTooltipModule,
            MatIconModule,
            ReactiveFormsModule] });
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LibCoberturasAutoModule, [{
        type: NgModule,
        args: [{
                declarations: [CoberturasAutoComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    MatButtonModule,
                    MatCardModule,
                    MatInputModule,
                    MatSelectModule,
                    MatSnackBarModule,
                    MatTooltipModule,
                    MatIconModule,
                    ReactiveFormsModule
                ],
                exports: [CoberturasAutoComponent],
                providers: [IconsService]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibCoberturasAutoModule, { declarations: [CoberturasAutoComponent], imports: [CommonModule,
        FormsModule,
        MatButtonModule,
        MatCardModule,
        MatInputModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatIconModule,
        ReactiveFormsModule], exports: [CoberturasAutoComponent] }); })();

/*
 * Public API Surface of coberturas-auto
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CoberturasAutoComponent, CoberturasAutoService, LibCoberturasAutoModule };
